// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"219":"296b4a7c","351":"2c7d46eb","455":"399606b7","499":"7d215f21","797":"16a6b632","852":"efabf713","859":"de05c6a5","936":"cacfa401","959":"f0f37949","977":"8c72bf08"}[chunkId] + ".chunk.js";
};